









































import { PageMode } from '@/main/utils/pageMode';
import { openEdit } from '@/main/router/routerPath';
import { listFactory } from '@/main/pages';

import { NAME as PARTNER } from '../partner/constants';
import { store } from './store/list';
import { NAME } from './constants';

export default listFactory(NAME, store).extend({
	methods: {
		editClick({ data }: { data: { ZAKAZNIKKON_ID: number; ZAKAZNIK_ID: number } }) {
			const pageName = data.ZAKAZNIKKON_ID ? NAME : PARTNER;
			const pageMode = PageMode.EDIT;
			const pageId = data.ZAKAZNIKKON_ID || data.ZAKAZNIK_ID;
			openEdit(pageName, pageMode, { id: pageId });
		},
		onCreateFyzickaOsobaClick() {
			openEdit(NAME, PageMode.CREATE, { props: true, filter: { ...this.createParams, PartnertypPzn: 1 } });
		},
		onCreateInstituceClick() {
			openEdit(NAME, PageMode.CREATE, { props: true, filter: { ...this.createParams, PartnertypPzn: 2 } });
		},
	},
});
